/** Shared marketing copy for white-label landing templates (mirrors classic Landing.js). */

export function heroEyebrow() {
  return '10 products · 22 AI tools · one subscription';
}

export function heroTitleLines() {
  return { line1: 'One platform for', line2: 'websites, leads & growth' };
}

export function heroDescription(brand) {
  return `${brand} connects lead generation, website building, multi-channel marketing, AI automation and e-commerce into a single, unified workspace — so you launch faster and grow smarter.`;
}

export function statsBar() {
  return [
    { value: '10+', label: 'Products in one platform' },
    { value: '22', label: 'AI tools included' },
    { value: '12,400+', label: 'Active users' },
    { value: '5 min', label: 'Avg. site launch time' },
  ];
}

export function productHighlights(brand) {
  return [
    {
      tag: 'Core',
      title: 'My Websites',
      subtitle: 'AI Website Builder',
      desc: `Build full-stack websites with AI. Use the step-by-step ${brand} Builder or start from a professionally designed template.`,
    },
    {
      tag: '22 Tools',
      title: 'AI Tools',
      subtitle: 'Content · Media · Bots',
      desc: 'A complete AI creative suite — Writer, Editor, Image, Voiceover, Video, Smart Bots and more.',
    },
    {
      tag: 'Multi-channel',
      title: 'Marketing Suite',
      subtitle: 'Email · SMS · WhatsApp',
      desc: 'Run campaigns, manage contacts and track results across Email, SMS and WhatsApp from one inbox.',
    },
    {
      tag: 'Prospecting',
      title: 'Lead Scraper',
      subtitle: 'Maps + enrichment',
      desc: 'Find high-intent local and B2B leads, then sync them into CRM and marketing automations.',
    },
    {
      tag: 'AI',
      title: 'AI Studio',
      subtitle: 'Agents & workflows',
      desc: 'Build custom AI agents with knowledge bases, triggers and runs that work 24/7.',
    },
    {
      tag: 'Operate',
      title: 'Operator & Commerce',
      subtitle: 'Bookings · products · CRM',
      desc: 'Run bookings, menus, products and operator dashboards for every site you publish.',
    },
  ];
}

export function flowSteps(brand) {
  return [
    {
      step: '01',
      title: 'Find Your Leads',
      module: 'Lead Scraper + Bot Leads',
      desc: 'Scrape high-intent prospects and deploy AI chatbots to capture inbound leads automatically.',
    },
    {
      step: '02',
      title: 'Engage & Nurture',
      module: 'Marketing Suite',
      desc: 'Reach leads across Email, SMS and WhatsApp with personalised campaigns and AI-written copy.',
    },
    {
      step: '03',
      title: 'Build Your Presence',
      module: 'Website Builder + AI Tools',
      desc: `Launch a production-ready website with AI. Generate images, content and pages inside ${brand}.`,
    },
    {
      step: '04',
      title: 'Convert & Sell',
      module: `${brand} Modules`,
      desc: 'Turn visitors into customers with e-commerce, CRM pipeline, bookings and payments.',
    },
    {
      step: '05',
      title: 'Automate & Scale',
      module: 'AI Studio + Automations',
      desc: 'Build custom AI agents and no-code workflows that run repeating tasks for you 24/7.',
    },
    {
      step: '06',
      title: 'Support & Retain',
      module: 'Support',
      desc: 'Keep customers happy with a built-in support desk and branded client experience.',
    },
  ];
}

export function testimonials(brand) {
  return [
    {
      quote: `${brand} replaced 4 tools for us. We launched 3 client sites in a single week with the AI builder.`,
      name: 'Sarah K.',
      role: 'Agency Owner',
      avatar: 'SK',
    },
    {
      quote: 'The WhatsApp marketing suite alone is worth 10x the subscription. The warmer and broadcast features are incredible.',
      name: 'Rahul M.',
      role: 'E-commerce Founder',
      avatar: 'RM',
    },
    {
      quote: `White-labeling was seamless. Our clients think it's our own product — and the ${brand} backend is a game changer.`,
      name: 'James T.',
      role: 'SaaS Reseller',
      avatar: 'JT',
    },
  ];
}

export function finalCta(brand) {
  return {
    title: 'Ready to build your AI-powered business?',
    subtitle: `Join 12,400+ builders who launched, grew and automated with ${brand}.`,
    note: 'No credit card required · Start free',
  };
}

export function dashboardMetrics() {
  return [
    { label: 'Leads scraped', value: '2,847', change: '+18% today' },
    { label: 'WhatsApp sent', value: '12.4K', change: 'Campaign live' },
    { label: 'Site visitors', value: '8,391', change: '+34% this week' },
    { label: 'Orders', value: '$38.9K', change: 'Multi-currency' },
    { label: 'AI agents', value: '4 active', change: 'Running 24/7' },
  ];
}
